import { useContext } from "react";
import { ApiTokenContext } from "./ApiClientContext";

/** A function that resolves the current bearer token (empty when auth is off). */
export type TokenGetter = () => Promise<string>;

/**
 * Returns the token getter for callers that bypass the openapi-fetch client
 * and issue a raw `fetch` — e.g. the SSE regen stream, which needs a
 * `ReadableStream` response body the typed client can't surface. The getter
 * is the same one {@link ApiClientProvider} feeds the client middleware, so
 * it honours `VITE_AUTH_DISABLED` (empty string → caller omits the
 * `Authorization` header) without re-deriving the auth branch here.
 */
export function useApiToken(): TokenGetter {
  const getter = useContext(ApiTokenContext);
  if (!getter) {
    throw new Error("useApiToken must be used inside ApiProvider");
  }
  return getter;
}
